import { useStaticQuery, graphql } from 'gatsby';

export const transformOpeningHours = (result) => {
  const type = result?.type || [];

  return {
    hasOpeningHours: type.length > 0,
    byDay: type.filter(({ __typename }) => __typename === 'STRAPI__COMPONENT_COMPANY_OPENING_HOURS_BY_DAY'),
    byLine: type.filter(({ __typename }) => __typename === 'STRAPI__COMPONENT_COMPANY_OPENING_HOURS_BY_LINE'),
    note: result?.note,
  };
};

const useOpeningHours = ({ companyId = null } = {}) => {
  const { allOpeningHours } = useStaticQuery(graphql`
    fragment OpeningHoursFragment on STRAPI_OPENING_HOURS {
      note
      type {
        __typename
        ...on STRAPI__COMPONENT_COMPANY_OPENING_HOURS_BY_DAY {
          id
          title
          monday
          tuesday
          wednesday
          thursday
          friday
          saturday
          sunday
        }
        ...on STRAPI__COMPONENT_COMPANY_OPENING_HOURS_BY_LINE {
          id
          title
          lines {
            id
            title
            value
          }
        }
      }
    }
    query Strapi4CompanyOpeningHoursQuery {
      allOpeningHours: allStrapiOpeningHours {
        nodes {
          companies {
            id
          }
          ...OpeningHoursFragment
        }
      }
    }
  `);

  const result = companyId
    ? allOpeningHours.nodes.find(
      ({ companies }) => (companies || []).some((company) => company?.id === companyId),
    )
    : allOpeningHours.nodes[0];

  return transformOpeningHours(result);
};

export default useOpeningHours;
